import { Route, Routes } from '@angular/router';
import { ValidationRulesPageComponent } from './components/validation-rules-page/validation-rules-page.component';

export const ValidationRulesRoutes: Routes = [
  {
    path: '',
    children: [
      <Route>{
        path: '',
        component: ValidationRulesPageComponent,
      },
    ],
  },
];
